module.exports = __webpack_public_path__ + "static/media/dog.bce28aa0.png";